<template>
    <div class="filter-table w-25">
        <div class="filter-table__input-wrap search-control">
            <input v-model="search"
                   @keyup.enter="onSearchByNumber()"
                   @keyup.delete="onCancelSearchByNumber()"
                   type="text"
                   class="search-control__input form-control"
                   placeholder="Поиск">
            <button @click="onSearchByNumber()" class="search-control__input-btn reset-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5" stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

<!--        <div class="filter-table__list-wrap">-->
<!--            <ul class="filter-table__list">-->
<!--                <li class="filter-table__item">-->
<!--                    <v-select class="ftoggle"-->
<!--                              @update:modelValue="onChangeFilter"-->
<!--                              v-model="primaryFilterVal"-->
<!--                              :options="primaryFilter"-->
<!--                              :searchable="false"-->
<!--                              :deselectFromDropdown="false"-->
<!--                              :appendToBody="true"-->
<!--                              :calculate-position="withPopper"-->
<!--                              :clearable="false">-->
<!--                    </v-select>-->
<!--                </li>-->

<!--                <li class="filter-table__item" v-show="primaryFilterVal === 'Клиент'">-->
<!--                    <select @change="onChangeClient($event)" v-model="client.selected" class="search-control__input form-control">-->
<!--                        <option selected value="">-->
<!--                            Все-->
<!--                        </option>-->
<!--                        <option v-for="client in client.items" v-bind:value="client.id">-->
<!--                            {{ client.name }}-->
<!--                        </option>-->
<!--                    </select>-->
<!--                </li>-->

<!--                <li class="filter-table__item" v-show="primaryFilterVal === 'Организация'">-->
<!--                    <select @change="onChangeOrg($event)" v-model="organization.selected" class="search-control__input form-control">-->
<!--                        <option selected value="">-->
<!--                            Все-->
<!--                        </option>-->
<!--                        <option v-for="organization in organization.items" v-bind:value="organization.id">-->
<!--                            {{ organization.name }}-->
<!--                        </option>-->
<!--                    </select>-->
<!--                </li>-->

<!--            </ul>-->
<!--        </div>-->
    </div>

    <div class="table-responsive">
        <table class="table">
            <thead>
            <tr>
                <th>Клиент</th>
                <th>Организация</th>
                <th>Номер документа</th>
                <th>Дата документа</th>
                <th class="text-center">Действия</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="document in documents">
                <td>{{ document.client_name }}</td>
                <td>{{ document.organization_name }}</td>
                <td>{{ document.invoice_number }}</td>
                <td>
                    <div class="table-state bg-lighten-blue">
                        {{ document.created_at }}
                    </div>
                </td>
                <td>
                    <div class="table-actions table-actions_gap-8px">
                        <a :href="'/documents/accounting-documents/downloadAct/' + document.id" class="btn btn-xs btn-primary">
                            Скачать акт
                        </a>
                        <a :href="'/documents/accounting-documents/downloadInvoice/' + document.id" class="btn btn-xs btn-outline-primary">
                            Скачать счет
                        </a>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <pagination-element :count="documents.count" :current_page="page" @pageChange="pageChange"></pagination-element>

    <Alert />

</template>

<script>

import { withPopper, dateFormat } from '../../../../utilites';
import PaginationElement from '../../../../elements/PaginationElement.vue';
import AccountingDocuments from '../../../../models/AccountingDocuments';
import ChangePage from '../../../../helpers/ChangePage';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "AccountingDocumentsComponent",
    components: { PaginationElement, Alert },
    props: {
        route_list: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            page: 1,
            limit: 10,
            client: {
                selected: null,
                items: []
            },
            organization: {
                selected: null,
                items: []
            },
            numberDocument: {
                value: null
            },
            primaryFilterVal: 'Все',
            date: null,
            documents: [],
            primaryFilter: [
                'Все',
                'Клиент',
                'Организация',
            ],
            search: null,
            forms: {
                period: {
                    from: null,
                    to: null
                }
            },
        };
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        withPopper,
        dateFormat,
        listClients: async function () {
            const data = await axios.get('/organizational/client/list', {}).then(response => {
                return response.data.status === 'ok' ? response.data.items : false
            }).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список список клиентов, что-то пошло не так' });
            });

            if (data) {
                this.client.items = data
            }
        },
        listDocuments: async function() {
            let response = await axios.get('/documents/accounting-documents/list', {params: {
                    page: this.page,
                    limit: this.limit,
                    search: this.search,
                    from: this.forms.period.from,
                    to: this.forms.period.to
                }}).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список документов, что-то пошло не так' });
            });

            if (response.data.status === 'ok') {
                this.documents = response.data.items;
                this.documents.count = response.data.pages;
            }

            if (response.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.data.message });
            }
        },
        listOrganizations: async function () {
            let resp = await axios.get('/organizational/organizations/list', {params: {
                    page: 1,
                    limit: 50,
                }}).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список организаций, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.organization.items = resp.data.items;
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.listDocuments();
        },
        onSearch: async function() {
            this.page = 1;
            await this.listDocuments();
        },
        onCancelSearchByNumber: async function () {
            if (this.numberDocument.value === '') {
                this.page = 1;
                this.listDocuments();
            }
        },
        onSearchByNumber: async function () {
            this.page = 1;
            this.listDocuments();
        },
        onChangeClient: async function (e) {
            this.client.selected = e.target.value;


            console.log(e)

            this.page = 1;
            this.listDocuments();
        },
        onChangeOrg: async function (e) {
            this.organization.selected = e.target.value;
            this.page = 1;
            this.listDocuments();
        },
        onChangeFilter: async function(filter) {
            if (filter === 'Все') {
                this.page = 1;
                this.client.selected = null;
                this.organization.selected = null;
                this.listDocuments();
            }
        },
    },
    mounted() {
        this.listDocuments();
        this.listOrganizations();
        this.listClients();
    }
};
</script>